<template>
  <el-checkbox-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    @update:modelValue="update"
  >
    <el-checkbox-button key="1" :value="false"> Direct </el-checkbox-button>
    <el-checkbox-button key="0" :value="true"> External </el-checkbox-button>
  </el-checkbox-group>
  <el-select v-else v-model="value" multiple @update:modelValue="update">
    <el-option key="1" label="Direct" :value="false"> Direct </el-option>
    <el-option key="0" label="External" :value="true"> External </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'PubTypeSelect',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    const update = function (newValue: any) {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    const { isDesktop } = useResize()

    return { update, isDesktop, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  box-shadow: none;
}
</style>
